import apiService from './apiService.js';

const resource = '/discipleship-groups';

export default {
    // getDiscipleshipGroupsTree(locationId) {
    //     // TODO, for now display as table
    //     return apiService.get(`${resource}/myDiscipleshipGroupsTree?location_id=${locationId}`);
    // },
    getDiscipleshipGroups(locationId) {
        return apiService.get(`${resource}/discipleshipGroupsAtLocation?location_id=${locationId}`);
    },
    getAddableLeadersList() {
        return apiService.get(`${resource}/listAddableLeaders`);
    },
    getAddableParticipantsList() {
        return apiService.get(`${resource}/listAddableParticipants`);
    },
    getCurrentParticipants(groupId) {
        return apiService.get(`${resource}/getGroupParticipants?group_id=${groupId}`);
    },
    getRemovableDisciplesList() {
        return apiService.get(`${resource}/listRemovableDisciples`);
    },
    addDiscipleshipGroup(leaderPersonId, participantPersonIds) {
        return apiService.post(`${resource}`,
            {
                leader_person_id: leaderPersonId,
                participant_person_ids: participantPersonIds
            });
    },
    endDiscipleshipGroup(groupId) {
        return apiService.delete(`${resource}/${groupId}`,
            {
                group_id: groupId,
            });
    },
    updateDiscipleshipGroup(groupId, leaderPersonId, participantPersonIds) {
        return apiService.put(`${resource}/${groupId}`,
            {
                group_id: groupId,
                leader_person_id: leaderPersonId,
                participant_person_ids: participantPersonIds
            });
    }
};
